<p-breadcrumb styleClass="p-mt-3" [model]="breadCrumbsModel" [home]="home"></p-breadcrumb>

<p-toast key="document-listing-messages" position="top-right"></p-toast>

<div class="p-p-2 p-mt-3">


    <!--    Spinner and Messages-->
    <div *ngIf="isLoading" class="p-d-flex p-ai-center p-jc-center" style="min-height: 70vmin">
        <div class="p-text-center">
            <div>
                <i class="pi pi-spinner pi-spin p-text-secondary" style="font-size: 2rem;"></i>
            </div>
            <div class="p-mt-4 p-text-secondary">
                Loading Documents !
            </div>
        </div>
    </div>

    <div *ngIf="(invoiceAndDocuments && !isLoading) ||(statementAndDocuments && !isLoading) || (bookingDocuments && !isLoading)">
        <!--Table View of Invoice & SOA-->
        <div class="p-pt-3 p-d-none p-d-md-block">

            <!--Table Invoices Data-->
            <p-table *ngIf="isInvoiceDocument" [scrollable]="true" [value]="[invoiceAndDocuments?.invoice]">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="p-py-3" style="width: 110px">
                            Type
                        </th>

                        <th style="width: 140px">
                            Invoice Number
                        </th>

                        <th style="width: 120px">
                            Invoice Date
                        </th>

                        <th style="width: 140px">
                            Booking Number
                        </th>

                        <th style="width: 170px">
                            Customer Reference Number
                        </th>

                        <th style="width: 150px">
                            Transport Document
                        </th>

                        <th style="width: 130px">
                            Bill To
                        </th>

                        <th style="width: 130px">
                            Invoice Amount
                        </th>


                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-invoice>
                    <tr class="divider-bottom">
                        <td [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'" style="width: 110px"
                            [ngClass]="getColourStatus(invoice?.shipmentType)"
                            class="p-py-4">{{invoice?.shipmentType ? invoice?.shipmentType : '-'}}</td>
                        <td [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'" style="width: 140px"
                            class="p-field-hover p-text-bold p-cursor">{{invoice?.invoiceNumber ? invoice?.invoiceNumber : '-'}}</td>
                        <td [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                            style="width: 120px">{{invoice?.invoiceDate ? (invoice?.invoiceDate | date: 'dd-MMM-yyyy') : '-'}}</td>
                        <td [class.p-cursor]="invoice?.bookingsCount > 0"
                            [class]="platform.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                            (mouseenter)="invoice.showMultipleBookings = true"
                            (mouseleave)="invoice.showMultipleBookings = false"
                            style="width: 140px">
                            <div
                                    class="p-d-flex p-ai-center p-jc-start">
                                <div>
                                    {{invoice?.bookingId ? invoice?.bookingId : '-'}}
                                </div>

                                <div class="p-ml-2"
                                     *ngIf="invoice?.bookingsCount > 0">
                                    <p-badge
                                            [value]="'+'+invoice?.bookingsCount"></p-badge>

                                </div>
                            </div>
                            <div *ngIf="invoice.showMultipleBookings">
                                <div class="p-mt-2 p-text-secondary"
                                     *ngFor="let bookingNumbers of invoice.multipleBookingNumbers?.split(',')">
                                    {{bookingNumbers}}
                                </div>
                            </div>

                        </td>
                        <td [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                            style="width: 170px">{{invoice?.customerReferenceNumber ? invoice?.customerReferenceNumber : '-'}}</td>
                        <td [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                            style="width: 150px">{{invoice?.transportDocuments ? invoice?.transportDocuments : '-'}}</td>
                        <td [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                            style="width: 130px">{{invoice?.billTo ? invoice?.billTo : '-'}}</td>
                        <td [class]="platform?.SAFARI ? 'p-text-wrap-safari' : 'p-text-wrap'"
                            style="width: 130px">{{invoice?.formattedInvoiceAmount ? invoice?.formattedInvoiceAmount : '-'}}</td>
                    </tr>
                </ng-template>
            </p-table>

            <!--Table Statement Data-->
            <div class="p-d-none p-d-xl-block">
                <p-table *ngIf="isStatementDocument" [scrollable]="true"
                         [value]="[statementAndDocuments?.statementOfAccount]">
                    <ng-template pTemplate="header">
                        <tr class="p-text-left width-100">
                            <th class="p-py-3" style="width: 11%;">

                                Invoice Number

                            </th>
                            <th style="width: 9.5%">

                                Bill to

                            </th>
                            <th style="width: 9.5%;">

                                Transport Document

                            </th>
                            <th style="width: 10.5%;">

                                Invoice Date

                            </th>
                            <th style="width: 10%">

                                Due Date

                            </th>
                            <th style="width: 10%">

                                Invoice Currency


                            </th>
                            <th style="width: 11%">

                                Amount

                            </th>
                            <th style="width: 10%;">

                                Transaction Amount

                            </th>
                            <th style="width: 9%">

                                Due

                            </th>
                            <th style="width: 9.5%">
                                Status
                            </th>
                            <!--                        <th style="width: 1.5%"></th>-->
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-statement>
                        <tr class="width-100 divider-bottom">
                            <td style="width: 11%;">
                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                     class="p-d-flex p-ai-center width-100">
                                    <div class="p-text-secondary p-text-bold">
                                        {{statement?.invoiceNumber ? statement?.invoiceNumber : '-'}}
                                    </div>
                                </div>
                            </td>
                            <td style="width: 9.5%">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                        {{statement?.billToPartyName ? statement?.billToPartyName : '-'}}
                                    </div>
                                </div>
                            </td>
                            <td style="width: 9.5%;">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                        {{statement?.transportDocument ? statement?.transportDocument : '-'}}
                                    </div>
                                </div>
                            </td>
                            <td style="width: 10.5%;">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                        {{statement?.invoiceDate ? (statement?.invoiceDate | date: 'dd-MMM-yyyy') : '-'}}
                                    </div>
                                </div>
                            </td>
                            <td style="width: 10%">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                        {{statement?.dueDate ? (statement?.dueDate | date: 'dd-MMM-yyyy') : '-'}}
                                    </div>
                                </div>
                            </td>
                            <td style="width: 10%">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                        {{statement?.invoiceCurrency ? statement?.invoiceCurrency : '-'}}
                                    </div>
                                </div>
                            </td>
                            <td style="width: 11%">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                        {{statement?.formattedInvoiceAmount ? statement?.formattedInvoiceAmount : '-'}}
                                    </div>
                                </div>
                            </td>
                            <td style="width: 10%;">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                        {{statement?.formattedTransactionalAmount ? statement?.formattedTransactionalAmount : '-'}}
                                    </div>
                                </div>
                            </td>
                            <td style="width: 9%">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                        {{statement?.formattedDueAmount ? statement?.formattedDueAmount : '-'}}
                                    </div>
                                </div>
                            </td>
                            <td style="width: 9.5%">
                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                     class="p-d-flex p-ai-center p-jc-between width-100">
                                    <div [class]="statement.status === 'Unpaid' ? 'p-text-danger' : 'p-text-warning'">
                                        {{statement?.status ? statement?.status : '-'}}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

            <!--Table Booking Data-->
            <div class="p-d-none p-d-xl-block">
                <p-table *ngIf="isBookingDocument" [value]="[bookingDocuments?.shipmentBooking]" [scrollable]="true">
                    <!--                        'calc(78vh - 10.5rem)'-->
                    <ng-template pTemplate="header">
                        <tr class="p-text-left width-100">
                            <th pSortableColumn="shipmentType" class="p-py-3" style="width: 7%;">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div>
                                        Type
                                    </div>
                                    <div class="p-ml-2">
                                        <p-sortIcon field="shipmentType"></p-sortIcon>
                                    </div>
                                </div>
                            </th>
                            <th style="width: 12%">
                                <div pSortableColumn="bookingId" class="p-d-flex p-ai-center width-100">
                                    <div>
                                        Booking Number
                                    </div>
                                    <div class="p-ml-2">
                                        <p-sortIcon field="bookingId"></p-sortIcon>
                                    </div>
                                </div>
                            </th>
                            <th pSortableColumn="customerReferenceNumber" style="width: 13.75%;">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div>
                                        Customer Reference Number
                                    </div>
                                    <div class="p-ml-2">
                                        <p-sortIcon field="customerReferenceNumber"></p-sortIcon>
                                    </div>
                                </div>
                            </th>
                            <th pSortableColumn="transportDocument" style="width: 10.5%;">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div style="width: 55%">
                                        Transport Document
                                    </div>
                                    <div class="p-ml-2">
                                        <p-sortIcon field="transportDocument"></p-sortIcon>
                                    </div>
                                </div>
                            </th>
                            <th pSortableColumn="bookingDate" style="width: 11.25%">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div>
                                        Booking Date
                                    </div>
                                    <div class="p-ml-2">
                                        <p-sortIcon field="bookingDate"></p-sortIcon>
                                    </div>
                                </div>
                            </th>
                            <th pSortableColumn="origin" style="width: 8%">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div>
                                        Origin
                                    </div>
                                    <div class="p-ml-2">
                                        <p-sortIcon field="origin"></p-sortIcon>
                                    </div>
                                </div>
                            </th>
                            <th pSortableColumn="departureDate" style="width: 9%">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div>
                                        Departure
                                    </div>
                                    <div class="p-ml-2">
                                        <p-sortIcon field="departureDate"></p-sortIcon>
                                    </div>
                                </div>
                            </th>
                            <th pSortableColumn="destination" style="width: 9%">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div>
                                        Destination
                                    </div>
                                    <div class="p-ml-2">
                                        <p-sortIcon field="destination"></p-sortIcon>
                                    </div>
                                </div>
                            </th>
                            <th pSortableColumn="arrivalDate" style="width: 9%">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div>
                                        Arrival
                                    </div>
                                    <div class="p-ml-2">
                                        <p-sortIcon field="arrivalDate"></p-sortIcon>
                                    </div>
                                </div>
                            </th>
                            <th pSortableColumn="status" style="width: 12%">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div>
                                        Status
                                    </div>
                                    <div class="p-ml-2">
                                        <p-sortIcon field="status"></p-sortIcon>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-booking>
                        <tr class="p-text-left divider-bottom width-100">
                            <td class="p-py-3" style="width: 7%">
                                <div [ngClass]="getColourStatus(booking?.shipmentType)"
                                     [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                     class="p-d-flex p-ai-center width-100">
                                    <div>
                                        {{booking?.shipmentType ? booking?.shipmentType : '-'}}
                                    </div>
                                </div>
                            </td>
                            <td
                                    style="width: 12%;">
                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                     class="p-d-flex p-ai-center width-100">
                                    <div class="p-text-bold">
                                        {{booking?.bookingId ? booking?.bookingId : '-'}}
                                    </div>
                                </div>
                            </td>
                            <td style="width: 13.75%;">
                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                     class="p-d-flex p-ai-center width-100">
                                    <div>
                                        {{booking?.customerReferenceNumber ? booking?.customerReferenceNumber : '-'}}
                                    </div>
                                </div>
                            </td>
                            <td style="width: 10.5%">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                         [style]="booking?.blCount > 0 ? 'width: 80%' : ''">
                                        {{booking?.transportDocument ? booking?.transportDocument : '-'}}
                                    </div>
                                    <div class="p-ml-2" *ngIf="booking?.blCount > 0">
                                        <p-badge [value]="booking?.blCount"></p-badge>
                                    </div>
                                </div>
                            </td>
                            <td style="width: 11.25%;">
                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                     class="p-d-flex p-ai-center width-100">
                                    <div>
                                        {{booking?.bookingDate ? (booking?.bookingDate | date: 'dd-MMM-yyyy') : '-'}}
                                    </div>
                                </div>
                            </td>
                            <td style="width: 8%;">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                        {{booking?.origin ? booking?.origin : '-'}}
                                    </div>
                                </div>
                            </td>
                            <td style="width: 9%;">
                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                     class="p-d-flex p-ai-center width-100">
                                    <div [class]="booking?.actualDepartureBoolean ? 'p-text-success' : 'p-text-warning'">
                                        {{booking?.departureDate ? (booking?.departureDate | date: 'dd-MMM-yyyy') : '-'}}
                                    </div>
                                </div>
                            </td>
                            <td style="width: 9%;">
                                <div class="p-d-flex p-ai-center width-100">
                                    <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                        {{booking?.destination ? booking?.destination : '-'}}
                                    </div>
                                </div>
                            </td>
                            <td style="width: 9%;">
                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                     class="p-d-flex p-ai-center width-100">
                                    <div [class]="booking?.actualArrivalBoolean ? 'p-text-success' : 'p-text-warning'">
                                        {{booking?.arrivalDate ? (booking?.arrivalDate | date: 'dd-MMM-yyyy') : '-'}}
                                    </div>
                                </div>
                            </td>
                            <td style="width: 12%;">
                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                     class="p-d-flex p-ai-center width-100">
                                    <div [class]="booking?.status?.length > 0 ? 'rounded-normal white-color p-py-1 p-px-2 ' : ''"
                                         [ngClass]="getColoredBookingStatus(booking?.status)">
                                        {{booking?.status ? booking?.status : '-'}}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-template>

                </p-table>
            </div>

            <div *ngIf="isStatementDocument" class="p-d-block p-d-xl-none">
                <documents-listing-tablet [isStatementDocument]="true"
                                          [statementAndDocuments]="statementAndDocuments"></documents-listing-tablet>
            </div>

            <div *ngIf="isBookingDocument" class="p-d-block p-d-xl-none">
                <documents-listing-tablet [isBookingDocument]="true"
                                          [bookingDocuments]="bookingDocuments"></documents-listing-tablet>
            </div>

        </div>

        <!--    Card View of Invoice & SOA-->
        <div class="p-pt-3 p-d-block p-d-md-none">

            <!--Invoice Card-->
            <div class="divider-bottom p-pb-3" *ngIf="isInvoiceDocument">


                <!--    Shipment Type & Invoice Number-->
                <div class="p-grid">
                    <div class="p-col-6">
                        <div class="p-header-font-size p-text-secondary p-text-bold">
                            Type
                        </div>
                        <div class="p-mt-1" [ngClass]="getColourStatus(invoiceAndDocuments?.invoice?.shipmentType)">
                            {{invoiceAndDocuments?.invoice?.shipmentType ? invoiceAndDocuments?.invoice?.shipmentType : '-'}}
                        </div>
                    </div>

                    <div class="p-col-6">
                        <div class="p-header-font-size p-text-secondary p-text-bold">
                            Invoice Number
                        </div>
                        <div class="p-text-bold p-mt-1">
                            <div class="p-d-flex p-ai-center">
                                <div class="p-text-secondary">
                                    {{invoiceAndDocuments?.invoice?.invoiceNumber ? invoiceAndDocuments?.invoice?.invoiceNumber : '-'}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--    Invoice Date & Booking Number-->
                <div class="p-grid p-mt-2">
                    <div class="p-col-6">
                        <div class="p-header-font-size p-text-secondary p-text-bold">
                            Invoice Date
                        </div>
                        <div class="p-mt-1">
                            {{invoiceAndDocuments?.invoice?.invoiceDate ? (invoiceAndDocuments?.invoice?.invoiceDate | date: 'dd-MMM-yyyy') : '-'}}
                        </div>
                    </div>

                    <div class="p-col-6">
                        <div class="p-header-font-size p-text-secondary p-text-bold">
                            Booking Number
                        </div>
                        <div
                                class="p-d-flex p-ai-center p-jc-start">
                            <div>
                                {{invoiceAndDocuments?.invoice?.bookingId ? invoiceAndDocuments?.invoice?.bookingId : '-'}}
                            </div>

                            <div class="p-ml-2 p-cursor"
                                 *ngIf="invoiceAndDocuments?.invoice?.bookingsCount > 0">
                                <p-badge (mouseenter)="invoiceAndDocuments.invoice.showMultipleBookings = true"
                                         (mouseleave)="invoiceAndDocuments.invoice.showMultipleBookings = false"
                                         [value]="'+'+invoiceAndDocuments?.invoice?.bookingsCount"></p-badge>

                            </div>
                        </div>
                        <div *ngIf="invoiceAndDocuments?.invoice.showMultipleBookings">
                            <div class="p-mt-2"
                                 *ngFor="let bookingNumbers of invoiceAndDocuments?.invoice.multipleBookingNumbers?.split(',')">
                                {{bookingNumbers}}
                            </div>
                        </div>
                    </div>
                </div>

                <!--    Customer Reference Number & Transport Document-->
                <div class="p-grid p-mt-2">
                    <div class="p-col-6">
                        <div class="p-header-font-size p-text-secondary p-text-bold">
                            Customer Ref. No.
                        </div>
                        <div class="p-mt-1">
                            {{invoiceAndDocuments?.invoice?.customerReferenceNumber ? invoiceAndDocuments?.invoice?.customerReferenceNumber : '-'}}
                        </div>
                    </div>

                    <div class="p-col-6">
                        <div class="p-header-font-size p-text-secondary p-text-bold">
                            Transport Document
                        </div>
                        <div class="p-mt-1">
                            {{invoiceAndDocuments?.invoice?.transportDocuments ? invoiceAndDocuments?.invoice?.transportDocuments : '-'}}
                        </div>
                    </div>
                </div>

                <!--    Bill To & Invoice Amount-->
                <div class="p-grid p-mt-2">
                    <div class="p-col-6">
                        <div class="p-header-font-size p-text-secondary p-text-bold">
                            Bill To
                        </div>
                        <div class="p-mt-1">
                            {{invoiceAndDocuments?.invoice?.billTo ? invoiceAndDocuments?.invoice?.billTo : '-'}}
                        </div>
                    </div>

                    <div class="p-col-6">
                        <div class="p-header-font-size p-text-secondary p-text-bold">
                            Invoice Amount
                        </div>
                        <div class="p-mt-1">
                            {{invoiceAndDocuments?.invoice?.formattedInvoiceAmount ? invoiceAndDocuments?.invoice?.formattedInvoiceAmount : '-'}}
                        </div>
                    </div>
                </div>
            </div>

            <!--Statement Card-->
            <div class="divider-bottom p-pb-3" *ngIf="isStatementDocument">
                <div class="p-grid">

                    <div class="p-col-6">
                        <div class="p-header-font-size p-text-secondary p-text-bold">
                            Invoice Number
                        </div>
                        <div class="p-text-bold p-mt-1">
                            <div class="p-text-secondary">
                                {{statementAndDocuments?.statementOfAccount?.invoiceNumber ? statementAndDocuments?.statementOfAccount?.invoiceNumber : '-'}}
                            </div>
                        </div>
                    </div>

                    <div class="p-col-6">
                        <div class="p-header-font-size p-text-secondary p-text-bold">
                            Bill to
                        </div>
                        <div class="p-mt-1">
                            {{statementAndDocuments?.statementOfAccount?.billTo ? statementAndDocuments?.statementOfAccount?.billTo : '-'}}
                        </div>
                    </div>

                </div>

                <!--    Invoice Date & Booking Number-->
                <div class="p-grid p-mt-2">
                    <div class="p-col-6">
                        <div class="p-header-font-size p-text-secondary p-text-bold">
                            Transport Document
                        </div>
                        <div class="p-mt-1">
                            {{statementAndDocuments?.statementOfAccount?.transportDocument ? statementAndDocuments?.statementOfAccount?.transportDocument : '-'}}
                        </div>
                    </div>

                    <div class="p-col-6">
                        <div class="p-header-font-size p-text-secondary p-text-bold">
                            Invoice Date
                        </div>
                        <div class="p-mt-1">
                            {{statementAndDocuments?.statementOfAccount?.invoiceDate ? (statementAndDocuments?.statementOfAccount?.invoiceDate | date: 'dd-MMM-yyyy') : '-'}}
                        </div>
                    </div>
                </div>

                <!--    Customer Reference Number & Transport Document-->
                <div class="p-grid p-mt-2">
                    <div class="p-col-6">
                        <div class="p-header-font-size p-text-secondary p-text-bold">
                            Due Date
                        </div>
                        <div class="p-mt-1">
                            {{statementAndDocuments?.statementOfAccount?.dueDate ? (statementAndDocuments?.statementOfAccount?.dueDate | date: 'dd-MMM-yyyy') : '-'}}
                        </div>
                    </div>

                    <div class="p-col-6">
                        <div class="p-header-font-size p-text-secondary p-text-bold">
                            Invoice Currency
                        </div>
                        <div class="p-mt-1">
                            {{statementAndDocuments?.statementOfAccount?.invoiceCurrency ? statementAndDocuments?.statementOfAccount?.invoiceCurrency : '-'}}
                        </div>
                    </div>
                </div>

                <!--    Bill To & Invoice Amount-->
                <div class="p-grid p-mt-2">
                    <div class="p-col-6">
                        <div class="p-header-font-size p-text-secondary p-text-bold">
                            Amount
                        </div>
                        <div class="p-mt-1">
                            {{statementAndDocuments?.statementOfAccount?.formattedInvoiceAmount ? statementAndDocuments?.statementOfAccount?.formattedInvoiceAmount : '-'}}
                        </div>
                    </div>

                    <div class="p-col-6">
                        <div class="p-header-font-size p-text-secondary p-text-bold">
                            Transactional Amount
                        </div>
                        <div class="p-mt-1">
                            {{statementAndDocuments?.statementOfAccount?.formattedTransactionalAmount ? statementAndDocuments?.statementOfAccount?.formattedTransactionalAmount : '-'}}
                        </div>
                    </div>
                </div>

                <div class="p-grid p-mt-2">
                    <div class="p-col-6">
                        <div class="p-header-font-size p-text-secondary p-text-bold">
                            Due
                        </div>
                        <div class="p-mt-1">
                            {{statementAndDocuments?.statementOfAccount?.formattedDueAmount ? statementAndDocuments?.statementOfAccount?.formattedDueAmount : '-'}}
                        </div>
                    </div>

                    <div class="p-col-6">
                        <div class="p-header-font-size p-text-secondary p-text-bold">
                            Status
                        </div>
                        <div class="p-mt-1"
                             [class]="statementAndDocuments?.statementOfAccount?.status === 'Unpaid' ? 'p-text-danger' : 'p-text-warning'">
                            {{statementAndDocuments?.statementOfAccount?.status ? statementAndDocuments?.statementOfAccount?.status : '-'}}
                        </div>
                    </div>
                </div>
            </div>

            <!--            Booking Card-->
            <div class="divider-bottom p-pb-3">
                <div class="p-grid divider-bottom p-pt-2 p-ai-center">
                    <div class="p-col-5 p-text-secondary">
                        <div class="p-header-font-size">
                            Booking Number
                        </div>
                        <div class="p-mt-1 p-text-bold">
                            {{bookingDocuments?.shipmentBooking?.bookingId ? bookingDocuments?.shipmentBooking?.bookingId : '-'}}
                        </div>
                    </div>
                    <div class="p-col-7">
                        <div class="p-d-flex p-jc-end p-ai-center">
                            <div [class]="bookingDocuments?.shipmentBooking?.status ? 'status-shape white-color p-p-1' : ''"
                                 [ngClass]="getColoredBookingStatus(bookingDocuments?.shipmentBooking?.status)">
                                {{bookingDocuments?.shipmentBooking?.status ? bookingDocuments?.shipmentBooking?.status : '-'}}
                            </div>
                        </div>
                    </div>
                </div>


                <div class="p-grid p-mt-2">
                    <div class="p-col-6">
                        <div class="p-text-bold p-header-font-size p-text-secondary">
                            Type
                        </div>
                        <div class="p-mt-1"
                             [ngClass]="getColourStatus(bookingDocuments?.shipmentBooking?.shipmentType)">
                            {{bookingDocuments?.shipmentBooking?.shipmentType ? bookingDocuments?.shipmentBooking?.shipmentType : '-'}}
                        </div>
                    </div>
                    <div class="p-col-6">
                        <div class="p-text-bold p-header-font-size p-text-secondary">
                            Customer Ref. No.
                        </div>
                        <div class="p-mt-1">
                            {{bookingDocuments?.shipmentBooking?.customerReferenceNumber ? bookingDocuments?.shipmentBooking?.customerReferenceNumber : '-'}}
                        </div>
                    </div>
                </div>

                <div class="p-grid p-mt-2">
                    <div class="p-col-6">
                        <div class="p-text-bold p-header-font-size p-text-secondary">
                            Transport Document
                        </div>
                        <div class="p-mt-1">
                            {{bookingDocuments?.shipmentBooking?.transportDocument ? bookingDocuments?.shipmentBooking?.transportDocument : '-'}}
                            <span class="p-ml-2"
                                  *ngIf="bookingDocuments?.shipmentBooking?.blCount > 0"> <p-badge
                                    [value]="bookingDocuments?.shipmentBooking?.blCount"></p-badge></span>
                        </div>
                    </div>
                    <div class="p-col-6">
                        <div class="p-text-bold p-header-font-size p-text-secondary">
                            Booking Date
                        </div>
                        <div class="p-mt-1">
                            {{bookingDocuments?.shipmentBooking?.bookingDate ? (bookingDocuments?.shipmentBooking?.bookingDate | date: 'dd-MMM-yyyy') : '-'}}
                        </div>
                    </div>
                </div>

                <div class="p-grid p-mt-2">
                    <div class="p-col-6">
                        <div class="p-text-bold p-header-font-size p-text-secondary">
                            Origin
                        </div>
                        <div class="p-mt-1">
                            {{bookingDocuments?.shipmentBooking?.origin ? bookingDocuments?.shipmentBooking?.origin : '-'}}

                        </div>
                    </div>
                    <div class="p-col-6">
                        <div class="p-text-bold p-header-font-size p-text-secondary">
                            Destination
                        </div>
                        <div class="p-mt-1">
                            {{bookingDocuments?.shipmentBooking?.destination ? bookingDocuments?.shipmentBooking?.destination : '-'}}
                        </div>
                    </div>
                </div>

                <div class="p-grid p-mt-2">
                    <div class="p-col-6">
                        <div class="p-text-bold p-header-font-size p-text-secondary">
                            Departure
                        </div>
                        <div class="p-mt-1"
                             [class]="bookingDocuments?.shipmentBooking?.actualDepartureBoolean ? 'p-text-success' : 'p-text-warning'">
                            {{bookingDocuments?.shipmentBooking?.departureDate ? (bookingDocuments?.shipmentBooking?.departureDate | date: 'dd-MMM-yyyy') : '-'}}

                        </div>
                    </div>
                    <div class="p-col-6">
                        <div class="p-text-bold p-header-font-size p-text-secondary">
                            Arrival
                        </div>
                        <div class="p-mt-1"
                             [class]="bookingDocuments?.shipmentBooking?.actualArrivalBoolean ? 'p-text-success' : 'p-text-warning'">
                            {{bookingDocuments?.shipmentBooking?.arrivalDate ? (bookingDocuments?.shipmentBooking?.arrivalDate | date: 'dd-MMM-yyyy') : '-'}}
                        </div>
                    </div>
                </div>

            </div>


        </div>

        <!--Document Listing Web Card-->

        <div class="position-center p-d-none p-d-md-block p-text-center"
             *ngIf="(invoiceAndDocuments?.documents?.length === 0 && !isLoading) ||(statementAndDocuments?.documents?.length === 0 && !isLoading)
            || (bookingDocuments?.documents?.length === 0 && !isLoading)">
            <h5 class="p-text-secondary">No Documents Found ! </h5>
        </div>

        <div *ngIf="(invoiceAndDocuments?.documents?.length > 0 && !isLoading) ||(statementAndDocuments?.documents?.length > 0 && !isLoading)
|| (bookingDocuments?.documents?.length > 0 && !isLoading)"
             [class.p-mt-3]="isStatementDocument"
             class="position-center p-d-none p-d-md-block">
            <div class="p-text-secondary p-text-bold">
                Documents
                ({{isInvoiceDocument ? invoiceAndDocuments?.documents?.length : (isBookingDocument ? bookingDocuments?.documents?.length : statementAndDocuments?.documents?.length)}}
                )
            </div>
            <div class="card p-mt-3">
                <!--            <div *ngFor="let document of statementAndDocuments?.documents">-->
                <div class="p-grid p-pt-3 p-ai-center p-jc-between" [class.divider-bottom]="!last"
                     *ngFor="let document of (isInvoiceDocument ? invoiceAndDocuments?.documents : (isBookingDocument ? bookingDocuments?.documents : statementAndDocuments?.documents)); let last=last">
                    <div class="p-col-12 p-md-6">
                        <div class="p-d-flex p-ai-center">
                            <div>
                                <img *ngIf="!document?.icon" src="assets/branding/shared-icons/doc-pdf.svg"/>
                                <i style="font-size: 2rem" class="p-text-secondary" *ngIf="document?.icon"
                                   [class]="document?.icon"></i>
                            </div>
                            <div class="p-ml-4">
                                <div class="p-text-secondary p-text-bold p-text-wrap"
                                     [class.p-text-wrap-safari]="platform.SAFARI">
                                    {{document?.documentXid ? document?.documentXid : '-'}}
                                </div>
                                <div class="p-mt-1">
                                    {{document?.generatedAt?.value ? (document?.generatedAt?.value | date: 'dd-MMM-yyyy') : '-'}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-col-12 p-md-6 p-xl-4">
                        <div class="p-d-flex p-ai-center p-jc-evenly">
                            <div>
                                <img (click)="!document?.isViewAllowed ? null: viewDocument(document)"
                                     class="p-cursor"
                                     [class.not-viewable]="!document.isViewAllowed"
                                     src="assets/branding/shared-icons/view-button.svg" pRipple
                                     alt="view-button">
                            </div>
                            <!--                            <div>-->
                            <!--                                <img class="p-cursor" src="assets/branding/shared-icons/print-button.svg" pRipple-->
                            <!--                                     [style]="document?.ownerDataQueryTypeGid === 'BILL' ? '' : 'cursor: not-allowed'"-->
                            <!--                                     alt="print-button">-->
                            <!--                            </div>-->
                            <div>
                                <img [style]="document?.isDownloadAllowed ? '' : 'cursor: not-allowed; opacity: .3'"
                                     (click)="document?.isDownloadAllowed ? downloadPdf(document) : null"
                                     *ngIf="!document?.isDownloading" class="p-cursor"
                                     src="assets/branding/shared-icons/download-button.svg" pRipple
                                     alt="view-button">
                                <i *ngIf="document?.isDownloading" class="pi pi-spin pi-spinner p-text-secondary"
                                   style="font-size: 2.5rem;"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="p-text-center p-d-block p-d-md-none p-mt-5"
             *ngIf="(invoiceAndDocuments?.documents?.length === 0 && !isLoading) ||(statementAndDocuments?.documents?.length === 0 && !isLoading)
|| (bookingDocuments?.documents?.length === 0 && !isLoading)">
            <h5>No Documents Found !</h5>
        </div>

        <div *ngIf="(invoiceAndDocuments?.documents?.length > 0 && !isLoading) ||(statementAndDocuments?.documents?.length > 0 && !isLoading)
|| (bookingDocuments?.documents?.length > 0 && !isLoading)"
             class="p-d-block p-d-md-none p-mt-5">
            <div class="p-text-secondary p-text-bold">
                ({{isInvoiceDocument ? invoiceAndDocuments?.documents?.length : (isBookingDocument ? bookingDocuments?.documents?.length : statementAndDocuments?.documents?.length)}}
                )
            </div>


            <div class="card p-mt-3">
                <!--            <div *ngFor="let document of statementAndDocuments?.documents">-->
                <div class="p-grid p-pt-3 p-ai-center p-jc-between" [class.divider-bottom]="!last"
                     *ngFor="let document of (isInvoiceDocument ? invoiceAndDocuments?.documents : (isBookingDocument ? bookingDocuments?.documents : statementAndDocuments?.documents)); let last=last">
                    <div class="p-col-12 p-md-6">
                        <div class="p-d-flex p-ai-center">
                            <div>
                                <img src="assets/branding/shared-icons/doc-pdf.svg"/>
                            </div>
                            <div class="p-ml-4">
                                <div class="p-text-secondary p-text-bold p-text-wrap">
                                    {{document?.documentXid ? document?.documentXid : '-'}}
                                </div>
                                <div class="p-mt-1">
                                    {{document?.generatedAt?.value ? (document?.generatedAt?.value | date: 'dd-MMM-yyyy') : '-'}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-col-12 p-md-6 p-xl-4">
                        <div class="p-d-flex p-ai-center p-jc-evenly">
                            <div>
                                <img (click)="!document?.isViewAllowed ? null: viewDocument(document)"
                                     class="p-cursor"
                                     [class.not-viewable]="!document.isViewAllowed"
                                     src="assets/branding/shared-icons/view-button.svg" pRipple
                                     alt="view-button">
                            </div>
                            <!--                            <div>-->
                            <!--                                <img class="p-cursor" src="assets/branding/shared-icons/print-button.svg" pRipple-->
                            <!--                                     [style]="document?.ownerDataQueryTypeGid === 'BILL' ? '' : 'cursor: not-allowed'"-->
                            <!--                                     alt="print-button">-->
                            <!--                            </div>-->
                            <div>
                                <img [style]="document?.isDownloadAllowed ? '' : 'cursor: not-allowed; opacity: .3'"
                                     (click)="document?.isDownloadAllowed ? downloadPdf(document) : null"
                                     *ngIf="!document?.isDownloading" class="p-cursor"
                                     src="assets/branding/shared-icons/download-button.svg" pRipple
                                     alt="view-button">
                                <i *ngIf="document?.isDownloading" class="pi pi-spin pi-spinner p-text-secondary"
                                   style="font-size: 2.5rem;"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>



